import { all, call, put, select, takeEvery } from 'redux-saga/effects';
import { trackCheckout } from '../../helper/utils/eventTrackGA.js';
import { formattedDate3, getTime } from '../../helper/utils/formattedDate.js';
import { getGrandTotal, getPriceMenuDiscount, getTotalDiscountsMenu, getTotalPricesMenu } from '../utils/menuItem.js';
import { getRounded } from '../utils/rounded.js';
import { totalTaxValue } from '../utils/tax.js';
import { doHandleState, SET_ERROR } from './onlineSales.actions.js';
import OnlineSalesServices from './onlineSales.services.js';
import { default as actions } from './onlineSales.types.js';

const generateRandomNumberString = (length = 6) => {
    let randomNumbers = '';
    for (let i = 0; i < length; i++) {
        randomNumbers += Math.floor(Math.random() * 10).toString();
    }
    return randomNumbers;
};

const salesOrderData = {
    SalesTypeCode: 1,
    SalesTypeName: 'online',
    OrderType: 1,
};

export function* HANDLE_STATE({ field, value }) {
    yield put({
        type: actions.SET_STATE,
        payload: {
            [field]: value,
        },
    });
}

export function* GET_PRODUCTS_AVAILABILITY({ payload }) {
    yield put(doHandleState('loadingOrder', true));
    yield put(doHandleState('data', []));
    yield put(doHandleState('detail', {}));

    try {
        yield put(OnlineSalesServices.doGetProductsAvailability(payload));
    } catch (e) {
        yield put(doHandleState('data', []));
        yield put(doHandleState('detail', {}));
        yield call(SET_ERROR, e);
    } finally {
        doHandleState('loadingOrder', false);
    }
}

export function* GET_PRODUCTS_DAYS_AVAILABILITY({ payload }) {
    yield put(doHandleState('loadingDetail', true));
    yield put(doHandleState('detail', {}));

    try {
        yield put(OnlineSalesServices.doGetProductsDaysAvailability(payload));
    } catch (e) {
        doHandleState('detail', {});
        yield call(SET_ERROR, e);
    } finally {
        doHandleState('loadingDetail', false);
    }
}

export function* ADD_TO_CART({ payload, onSuccess }) {
    try {
        const cart = yield select((state) => state?.onlineSales.cart) || [];
        const productPage = JSON.parse(localStorage.getItem('product') || '{}');
        const product = payload['product'] || {};
        const minors = payload['minors'] || [];
        const rooms = payload['rooms'] || [];
        const packages = payload['packages'] || [];

        const price = parseFloat(product['basePrice']);
        const qty = parseFloat(payload['qty']);
        const taxOn = parseInt(product['taxOn']);
        const inclTax = product['vatInclusiveFlag'] == 1;
        const taxPrc = taxOn == 1 ? 11 : 10;
        const mappedMinors = minors.map((minor) => {
            return {
                ...minor,
                BillNo: '',
                ChildrenID: minor['childrenID'] || '',
                MemberNo: minor['memberNo'] || '',
            };
        });

        const taxVal = inclTax ? 0 : price * qty * (taxPrc / 100);

        const result = {
            ...product,
            qty,
            taxPrc,
            taxVal,
            servPrc: 0,
            servVal: 0,
            discPrc: 0,
            discVal: 0,
            discValuex: 0,
            price,
            Price1: price,
            Price3: price,
            Price4: price,
            Price5: price,
            Price6: price,
            Price7: price,
            Price8: price,
            Price9: price,
            Price10: price,
            productType: productPage['id'] || '',
            date: payload['date'],
            timeSlot: payload['timeSlot'],
            id: generateRandomNumberString(6),
            minors: mappedMinors,
            rooms,
            isParentMenu: '1',
            combo: (product['combo'] || [])?.map((combo) => {
                // const price = parseFloat(combo['basePrice']);
                const price = 0;
                const taxOn = parseInt(combo['taxOn']);
                const inclTax = combo['vatInclusiveFlag'] == 1;
                const taxPrc = taxOn == 1 ? 11 : 10;

                const taxVal = price > 0 ? (inclTax ? 0 : price * qty * (taxPrc / 100)) : 0;

                return {
                    ...combo,
                    qty,
                    taxPrc,
                    taxVal,
                    servPrc: 0,
                    servVal: 0,
                    discPrc: 0,
                    discVal: 0,
                    discValuex: 0,
                    price,
                    Price1: price,
                    Price3: price,
                    Price4: price,
                    Price5: price,
                    Price6: price,
                    Price7: price,
                    Price8: price,
                    Price9: price,
                    Price10: price,
                    id: generateRandomNumberString(6),
                    isParentMenu: '0',
                    productParentId: product['menuCode'] || '',
                };
            }),
        };

        const mappedPackages = (packages || [])?.map((pkg) => {
            const isDefaultMenu = +(pkg?.isDefaultMenu ?? '0') === 1;
            const price = parseFloat(pkg['basePrice']);
            const productQty = parseFloat(payload['qty']);
            const qtyUsed = parseFloat(pkg['qtyUsed']);
            const qty = isDefaultMenu ? qtyUsed * productQty : +(pkg?.qty ?? '0');
            const taxOn = parseInt(pkg['taxOn']);
            const inclTax = pkg['vatInclusiveFlag'] == 1;
            const taxPrc = taxOn == 1 ? 11 : 10;

            const taxVal = price > 0 ? (inclTax ? 0 : price * qty * (taxPrc / 100)) : 0;

            return {
                ...pkg,
                parentMenu: result,
                parentMenuCode: result['menuCode'] || '',
                isParentMenu: '0',
                productParentId: result['menuCode'] || '',
                isMenuAddOns: true,
                isMenuPackage: true,
                isCanDelete: !isDefaultMenu,
                date: payload['date'],
                timeSlot: {},
                qty,
                taxPrc,
                taxVal,
                servPrc: 0,
                servVal: 0,
                discPrc: 0,
                discVal: 0,
                discValuex: 0,
                price,
                Price1: price,
                Price3: price,
                Price4: price,
                Price5: price,
                Price6: price,
                Price7: price,
                Price8: price,
                Price9: price,
                Price10: price,
                id: generateRandomNumberString(6),
            };
        });

        yield put(doHandleState('cart', [...cart, result, ...mappedPackages]));

        if (typeof onSuccess === 'function') {
            onSuccess();
        }

        yield put(doHandleState('detail', {}));
    } catch (error) {
        yield call(SET_ERROR, error);
    }
}

export function* DELETE_ITEM_CART({ payload }) {
    const { id = '', product = {} } = payload;

    try {
        const cart = yield select((state) => state?.onlineSales.cart) || [];
        const findItem = product;
        const isMenuAddOns = findItem ? (findItem?.isMenuAddOns ?? false) : false;
        const isDefaultMenu = +(findItem ? (findItem?.isDefaultMenu ?? '0') : '0') === 1;

        const filteredCart = (cart || [])?.filter((item) => item['id'] !== id);

        if (isMenuAddOns && !isDefaultMenu) {
            yield put(doHandleState('cart', filteredCart));
        } else {
            // delete parent and add-ons menu at the same times
            const filteredAddOns = filteredCart?.filter((item) => {
                const parentMenuCode = item?.parentMenuCode || '';

                if (parentMenuCode) {
                    return item?.menuCode === parentMenuCode;
                }

                return true;
            });

            yield put(doHandleState('cart', filteredAddOns));
        }
    } catch (error) {
        yield call(SET_ERROR, error);
    }
}

export function* UPDATE_ITEM_CART({ payload, onSuccess }) {
    const { qty = 0, timeSlot = '', date = '', id = '' } = payload;

    try {
        const cart = yield select((state) => state?.onlineSales.cart) || [];

        const updatedCart = cart.map((item) => {
            // const price = parseFloat(item['basePrice']);
            const price = 0;
            const taxOn = parseInt(item['taxOn']);
            const inclTax = item['vatInclusiveFlag'] == 1;
            const taxPrc = taxOn == 1 ? 11 : 10;

            const taxVal = price > 0 ? (inclTax ? 0 : price * qty * (taxPrc / 100)) : 0;

            if (id == item['id']) {
                return {
                    ...item,
                    qty,
                    taxPrc,
                    taxVal,
                    servPrc: 0,
                    servVal: 0,
                    discPrc: 0,
                    discVal: 0,
                    discValuex: 0,
                    date,
                    timeSlot,
                };
            }

            return item;
        });

        if (typeof onSuccess === 'function') {
            onSuccess();
        }

        yield put(doHandleState('cart', updatedCart));
        yield put(doHandleState('detail', {}));
    } catch (error) {
        yield call(SET_ERROR, error);
    }
}

export function* CREATE_ORDER({ payload }) {
    doHandleState('loadingOrder', true);

    try {
        const { waiver = {}, minor = [] } = yield select((state) => state?.waiver) || {};

        const cart = yield select((state) => state?.onlineSales?.cart);
        const parentCode = yield select((state) => state?.waiver?.parentCode);
        const outlet = JSON.parse(localStorage.getItem('outlet') || '{}');
        const minors = minor.map((el) => ({ ...el, parentId: payload?.phone ?? '' }));

        const isSubscription = cart.some((item) => item.menuType === 'subscription');
        const isForParty = cart.some((item) => item.menuType === 'party' && (item?.rooms ?? []).length > 0);

        const orderType = {
            isForParty,
            isSubscription,
            isTicketing: !isForParty && !isSubscription,
        };

        // FOR PARTY
        const payloadParty = {
            partyName: payload?.partyName || '',
            celebrantName: payload?.celebrantName || '',
            celebrantAge: payload?.celebrantAge || '',
            remarks: payload?.remarks || '',
        };

        // Helper untuk menentukan tipe pesanan secara tunggal
        const getOrderCategory = (cart) => {
            if (cart.some((item) => item.menuType === 'party')) return 'PARTY';
            if (cart.some((item) => item.menuType === 'subscription')) return 'SUBSCRIPTION';
            return 'TICKETING'; // Default
        };

        // Penggunaan
        const orderCategory = getOrderCategory(cart);

        const combos = (cart?.map((item) => (item['combo'] || []).flat()) || []).flat();

        let $getInterval = 1;
        let $getIntervalUnit = 'month';

        if (orderCategory === 'SUBSCRIPTION') {
            $getInterval = cart.find((item) => item.menuType === 'subscription')?.interval || 1;
            $getIntervalUnit = cart.find((item) => item.menuType === 'subscription')?.intervalUnit || 'month';
        }

        const items = cart?.map((item, index) => {
            const qty = parseFloat(item['qty'] || '0');
            const price = parseFloat(item['price'] || '0');
            const timeslot = item['timeSlot'] || {};
            const uniqueId = (index + 1).toString();
            const isNeedTimeslot = +item['isNeedTimeSlot'] === 1;

            return {
                uniqueId,
                isNeedTimeSlot: item['isNeedTimeSlot'],
                isOnlineSales: item['isOnlineSales'],
                isParentMenu: item['isParentMenu'],
                productParentId: item['productParentId'] || '',
                isRecurring: item['isRecurring'],
                productOrderNo: uniqueId,
                groupCode: item['groupCode'] || '',
                categoryCode: item['cateCode'] || '',
                productId: item['menuCode'] || '',
                productName: item['menuName'] || '',
                qty,
                price,
                subTotal: qty * price,
                discountCode: item['discCode'] || '',
                discount: parseFloat(item['discVal'] || '0'),
                totalDiscounts: getPriceMenuDiscount(item),
                promoCode: item['promoCode'] || '',
                taxPrc: parseFloat(item['taxPrc'] || '0'),
                totalTax: parseFloat(item['taxValue'] || '0'),
                servicePrc: parseFloat(item['servPrc'] || '0'),
                totalService: parseFloat(item['servValue'] || '0'),
                rooms: item['rooms'] || [],
                availabilities: isNeedTimeslot
                    ? {
                          date: formattedDate3(new Date(item['date'])),
                          onlineSalesOpen: 0,
                          sessions: {
                              uniqueId,
                              sessionId: timeslot['ModifItemCode'] || '',
                              sessionName: timeslot['sessionName'] || '',
                          },
                      }
                    : {},
            };
        });

        const mappingCombos = combos?.map((combo, index) => {
            const uniqueId = (index + 1).toString();
            const qty = parseFloat(combo['qty'] || '0');
            const price = parseFloat(combo['price'] || '0');

            return {
                uniqueId,
                isNeedTimeSlot: combo['isNeedTimeSlot'],
                isOnlineSales: combo['isOnlineSales'],
                isParentMenu: combo['isParentMenu'],
                productParentId: combo['productParentId'] || '',
                isRecurring: combo['isRecurring'],
                productOrderNo: uniqueId,
                groupCode: combo['groupCode'] || '',
                categoryCode: combo['cateCode'] || '',
                productId: combo['menuCode'] || '',
                productName: combo['menuName'] || '',
                qty,
                price,
                subTotal: qty * price,
                discountCode: combo['discCode'] || '',
                discount: parseFloat(combo['discVal'] || '0'),
                totalDiscounts: getPriceMenuDiscount(combo),
                promoCode: combo['promoCode'] || '',
                taxPrc: parseFloat(combo['taxPrc'] || '0'),
                totalTax: parseFloat(combo['taxValue'] || '0'),
                servicePrc: parseFloat(combo['servPrc'] || '0'),
                totalService: parseFloat(combo['servValue'] || '0'),
            };
        });

        const mappingMembers = cart?.map((item) => item['minors'] || []).flat();

        const payloadPayment = {
            header: {
                '3ds':
                    orderCategory === 'SUBSCRIPTION'
                        ? {
                              token_id: payload.token_id ?? '',
                              email: payload.email,
                          }
                        : {},
                batchNo: generateRandomNumberString(10),
                billTime: getTime(),
                salesTypeCode: 'online',
                orderType: orderType.isForParty ? 'party' : orderType.isSubscription ? 'subscription' : 'online',
                billDate: formattedDate3(cart[0]['date']),
                outletCode: outlet['outletCode'] || '',
                brandCode: outlet['brandCode'] || '',
                interval: $getInterval,
                intervalUnit: $getIntervalUnit,
                amounts: {
                    subTotal: getTotalPricesMenu(cart, salesOrderData),
                    totalDiscount: getTotalDiscountsMenu(cart, salesOrderData),
                    totalService: 0,
                    totalTax: totalTaxValue(cart, salesOrderData),
                    taxExclusive: totalTaxValue(cart, salesOrderData),
                    totalRounded: getRounded(cart, salesOrderData),
                    grandTotal: getGrandTotal(cart, salesOrderData),
                    transactionFees: 0,
                    fees: 0,
                    feesTax: 0,
                    deposit: 0,
                    depositIncFees: 0,
                    paid: getTotalPricesMenu(cart, salesOrderData),
                },
                memberTrx: mappingMembers,
            },
            items: [...items, ...mappingCombos].map((item, index) => {
                const uniqueId = (index + 1).toString();

                return {
                    ...item,
                    uniqueId,
                    productOrderNo: uniqueId,
                };
            }),
            waiverData: {
                uniqueId: generateRandomNumberString(10),
                userId: waiver['id'] || parentCode || '',
                firstName: payload.firstName || payload.fullname || waiver['fullname'] || '',
                lastName: payload.lastName || payload.fullname || waiver['fullname'] || '',
                email: payload.email || waiver['email'] || '',
                phone: payload.phone || waiver['phone'] || '',
                address: payload.address || waiver['address'] || '',
                childrens: minors.map((child) => ({
                    childrenName: child['name'] || '',
                    childrenID: child['childrenID'] || payload.phone || waiver['phone'] || '',
                    birthDate: child['birthDate'] || '',
                })),
            },
        };

        const emailWaiver = (payloadPayment['waiverData']['email'] || '').toString().trim();
        const phoneWaiver = (payloadPayment['waiverData']['phone'] || '').toString().trim();

        if (Object.keys(waiver).length === 0 || emailWaiver == '' || phoneWaiver == '') {
            yield put(doError('Failed! Waiver not found, cannot continue payment. Please sign in again.', 'Waiver', 'Payment!.'));
            return;
        }
        const trackPayload = {
            value: payloadPayment['header']['amounts']['grandTotal'],
            currency: 'IDR',
            items: (payloadPayment['items'] || []).map((item) => ({
                item_id: item['productId'] || '',
                item_name: item['productName'] || '',
                item_category: item['categoryCode'] || '',
                price: +(item['price'] || 0),
                quantity: item['qty'],
            })),
        };

        trackCheckout(trackPayload);
        yield put(OnlineSalesServices.doHandleGeneratePaymentLink(payloadPayment, orderCategory, payloadParty));
    } catch (error) {
        yield call(SET_ERROR, error);
        console.log(error);
    } finally {
        doHandleState('loadingOrder', false);
    }
}

export function* GET_BRANDS({ payload }) {
    yield put(doHandleState('loadingBrand', true));

    try {
        yield put(OnlineSalesServices.doHandleGetBrands(payload));
    } catch (error) {
        console.log(error);
    } finally {
        yield put(doHandleState('loadingBrand', false));
    }
}

export function* GET_OUTLET() {
    yield put(doHandleState('loadingOutlet', true));

    try {
        yield put(OnlineSalesServices.doHandleGetOutlets());
    } catch (error) {
        console.log(error);
    } finally {
        yield put(doHandleState('loadingOutlet', false));
    }
}

export function* GET_HISTORY_TRANSACTIONS() {
    yield put(doHandleState('loadingHistory', true));

    try {
        yield put(OnlineSalesServices.doHandleGetHistoryTransactions());
    } catch (error) {
        console.log(error);
    } finally {
        yield put(doHandleState('loadingHistory', false));
    }
}

export function* GET_HISTORY_TRANSACTION_DETAIL({ payload }) {
    yield put(doHandleState('loadingHistory', true));

    try {
        const { billNo = '', orderType = 'REGULAR' } = payload || {};
        yield put(OnlineSalesServices.doHandleGetHistoryTransactionDetail(billNo || '', orderType || ''));
    } catch (error) {
        console.log(error);
    } finally {
        yield put(doHandleState('loadingHistory', false));
    }
}

export function* GET_LOYALTY_TIER() {
    yield put(doHandleState('loadingPoints', true));

    try {
        yield put(OnlineSalesServices.doHandleGetLoyaltyTier());
    } catch (error) {
        console.log(error);
    } finally {
        yield put(doHandleState('loadingPoints', false));
    }
}

export function* GET_AVAILABLE_REWARDS() {
    yield put(doHandleState('loadingPoints', true));

    try {
        yield put(OnlineSalesServices.doHandleGetAvailableRewards());
    } catch (error) {
        console.log(error);
    } finally {
        yield put(doHandleState('loadingPoints', false));
    }
}

export function* GET_POINT_HISTORY() {
    yield put(doHandleState('loadingPoints', true));

    try {
        yield put(OnlineSalesServices.doHandleGetPointHistory());
    } catch (error) {
        console.log(error);
    } finally {
        yield put(doHandleState('loadingPoints', false));
    }
}

export function* GET_REDEEM_HISTORY() {
    yield put(doHandleState('loadingPoints', true));

    try {
        yield put(OnlineSalesServices.doHandleGetRedeemHistory());
    } catch (error) {
        console.log(error);
    } finally {
        yield put(doHandleState('loadingPoints', false));
    }
}

export function* TRIGGER_REDEEM({ payload, onSuccess }) {
    try {
        yield put(OnlineSalesServices.doHandleTriggerRedeem(payload, onSuccess));
    } catch (error) {
        console.log(error);
    }
}

export default function* rootSaga() {
    yield all([
        takeEvery(actions.HANDLE_STATE, HANDLE_STATE),
        takeEvery(actions.GET_PRODUCTS_AVAILABILITY, GET_PRODUCTS_AVAILABILITY),
        takeEvery(actions.GET_PRODUCTS_DAYS_AVAILABILITY, GET_PRODUCTS_DAYS_AVAILABILITY),
        takeEvery(actions.ADD_TO_CART, ADD_TO_CART),
        takeEvery(actions.DELETE_ITEM_CART, DELETE_ITEM_CART),
        takeEvery(actions.UPDATE_ITEM_CART, UPDATE_ITEM_CART),
        takeEvery(actions.CREATE_ORDER, CREATE_ORDER),
        takeEvery(actions.GET_BRANDS, GET_BRANDS),
        takeEvery(actions.GET_OUTLET, GET_OUTLET),
        takeEvery(actions.GET_HISTORY_TRANSACTIONS, GET_HISTORY_TRANSACTIONS),
        takeEvery(actions.GET_HISTORY_TRANSACTION_DETAIL, GET_HISTORY_TRANSACTION_DETAIL),
        takeEvery(actions.GET_LOYALTY_TIER, GET_LOYALTY_TIER),
        takeEvery(actions.GET_AVAILABLE_REWARDS, GET_AVAILABLE_REWARDS),
        takeEvery(actions.GET_POINT_HISTORY, GET_POINT_HISTORY),
        takeEvery(actions.GET_REDEEM_HISTORY, GET_REDEEM_HISTORY),
        takeEvery(actions.TRIGGER_REDEEM, TRIGGER_REDEEM),
    ]);
}
